import { MDBIcon } from "mdb-react-ui-kit";
import { useContext } from 'react';
import useResumeLanguageSkillsHandlers from "../../../context/resume/hooks/resume-language-skills-handlers";
import { ResumeContext } from "../../../context/resume/resume-context";
import { TranslationContext } from "../../../context/translations/translations-context";
import ReferentialSelect from "../../assets/ReferentialSelect";

export default function LanguageSkillItem( { item, numberOfItems, } ) {

    const { translations, displayLanguage } = useContext( TranslationContext );
    const { refLanguages, refLanguageLevels } = useContext( ResumeContext );
    const { handleChange, handleMoveDown, handleMoveUp, handleRemove } = useResumeLanguageSkillsHandlers();

    return (
        <tr key={ item.order }>
            <th colSpan="1" style={ { padding: "0px 2px" } }>
                <ReferentialSelect
                    name={ `languageSkill[${ item.order }].language` }
                    elementId={ `languageSkill[${ item.order }].language` }
                    firstOption={ translations.languageSkillsSection.selectLanguageLabel }
                    selectedItem={ item.language?.code || "" }
                    referential={ refLanguages }
                    displayLanguage={ displayLanguage }
                    handleChange={
                        ( event ) =>
                            handleChange( {
                                ...item,
                                language: refLanguages.find( l => l.code === event.target.value )
                            } )
                    }
                />
            </th>
            <td style={ { padding: "0px 2px" } }>
                <ReferentialSelect
                    name={ `languageSkill[${ item.order }].listeningComprehensionLevel` }
                    elementId={ `languageSkill[${ item.order }].listeningComprehensionLevel` }
                    firstOption={ translations.languageSkillsSection.selectLevelLabel }
                    selectedItem={ item.listeningComprehensionLevel?.code || "" }
                    referential={ refLanguageLevels }
                    displayLanguage={ displayLanguage }
                    handleChange={
                        ( event ) =>
                            handleChange( {
                                ...item,
                                listeningComprehensionLevel: refLanguageLevels.find( ll => ll.code === event.target.value )
                            } )
                    }
                />
            </td>
            <td style={ { padding: "0px 2px" } }>
                <ReferentialSelect
                    name={ `languageSkill[${ item.order }].readingComprehensionLevel` }
                    elementId={ `languageSkill[${ item.order }].readingComprehensionLevel` }
                    firstOption={ translations.languageSkillsSection.selectLevelLabel }
                    selectedItem={ item.readingComprehensionLevel?.code || "" }
                    referential={ refLanguageLevels }
                    displayLanguage={ displayLanguage }
                    handleChange={
                        ( event ) =>
                            handleChange( {
                                ...item,
                                readingComprehensionLevel: refLanguageLevels.find( ll => ll.code === event.target.value )
                            } )
                    }
                />
            </td>
            <td style={ { padding: "0px 2px" } }>
                <ReferentialSelect
                    name={ `languageSkill[${ item.order }].continuousOralExpressionLevel` }
                    elementId={ `languageSkill[${ item.order }].continuousOralExpressionLevel` }
                    firstOption={ translations.languageSkillsSection.selectLevelLabel }
                    selectedItem={ item.continuousOralExpressionLevel?.code || "" }
                    referential={ refLanguageLevels }
                    displayLanguage={ displayLanguage }
                    handleChange={
                        ( event ) =>
                            handleChange( {
                                ...item,
                                continuousOralExpressionLevel: refLanguageLevels.find( ll => ll.code === event.target.value )
                            } )
                    }
                />
            </td>
            <td style={ { padding: "0px 2px" } }>
                <ReferentialSelect
                    name={ `languageSkill[${ item.order }].oralInteractionLevel` }
                    elementId={ `languageSkill[${ item.order }].oralInteractionLevel` }
                    firstOption={ translations.languageSkillsSection.selectLevelLabel }
                    selectedItem={ item.oralInteractionLevel?.code || "" }
                    referential={ refLanguageLevels }
                    displayLanguage={ displayLanguage }
                    handleChange={
                        ( event ) =>
                            handleChange( {
                                ...item,
                                oralInteractionLevel: refLanguageLevels.find( ll => ll.code === event.target.value )
                            } )
                    }
                />
            </td>
            <td style={ { padding: "0px 2px" } }>
                <ReferentialSelect
                    name={ `languageSkill[${ item.order }].writingExpressionLevel` }
                    elementId={ `languageSkill[${ item.order }].writingExpressionLevel` }
                    firstOption={ translations.languageSkillsSection.selectLevelLabel }
                    selectedItem={ item.writingExpressionLevel?.code || "" }
                    referential={ refLanguageLevels }
                    displayLanguage={ displayLanguage }
                    handleChange={
                        ( event ) =>
                            handleChange( {
                                ...item,
                                writingExpressionLevel: refLanguageLevels.find( ll => ll.code === event.target.value )
                            } )
                    }
                />
            </td>
            <td className='border-bottom-0 border-top-0'>
                <div className="d-flex align-items-center">
                    <MDBIcon
                        fas
                        icon="arrow-up"
                        className="m-1"
                        onClick={ () => item.order !== 0 && handleMoveUp( item ) }
                        style={ { cursor: item.order !== 0 ? "pointer" : "default" } }
                        color={ item.order !== 0 ? "light" : "muted" }
                        role="button"
                        title="Remonter la formation"
                    />
                    <MDBIcon
                        fas
                        icon="arrow-down"
                        className="m-1"
                        onClick={ () => item.order !== numberOfItems - 1 && handleMoveDown( item ) }
                        style={ { cursor: item.order !== numberOfItems - 1 ? "pointer" : "default" } }
                        color={ item.order !== numberOfItems - 1 ? "light" : "muted" }
                        role="button"
                        title="Descendre la formation"
                    />
                    <MDBIcon
                        fas
                        icon="trash-alt"
                        className={ `py-5` }
                        color='light'
                        onClick={ () =>  window.confirm(translations.general.confirmationMessage) && handleRemove( item ) }
                        role="button"
                        size="lg"
                    />
                </div>
            </td>
        </tr>
    );
}
